import React from 'react'
import Footer from './Footer'
import Navigation from './Navigation'

function ContactUs() {
  return (
  <>
  <Navigation/>
    <section className="contact-us">
        <div className="container">
            <div className="inner-wrapper d-flex align-items-center justify-content-between mb-5">
                <div className="left-col">
                    <h2 className="contact-title">
                        Har du noen spørsmål? Ta kontakt med oss!
                    </h2>
                    <p className="contact-text">
                        Ta kontakt med oss! Vi setter pris på dine tilbakemeldinger og er alltid her for å hjelpe deg. Legg igjen en beskjed, så kommer vi tilbake til deg så snart som mulig.
                    </p>
                </div>
                <div className="right-col">
                    <form action="">
                        <div className="input-wrapper">
                            <label for="name">
                                Navn <span>(required)</span> 
                            </label>
                            <input type="text" name="name" id="name"/>
                        </div>
                        <div className="input-wrapper">
                            <label for="email">
                                Email <span>(required)</span> 
                            </label>
                            <input type="text" name="email" id="email"/>
                        </div>
                        <div className="input-wrapper">
                            <label for="comment">
                                Melding
                            </label>
                            <textarea name="comment" id="comment"></textarea>
                        </div>
                        <button type="button">
                            Send inn
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </section>
    <Footer/>
  </>
  )
}

export default ContactUs